import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import Button from '../Button';
import './DefaultButton.scss';
import useIntlMessage from '@app/hooks/use-intl-message';
import SvgIconUse from '@SvgIconUse';

const DefaultButton = React.forwardRef(
  ({ className, onClick, locKey, loading = false, hidden = false, disabled = false, secondary = false, ...props }, ref) => {
    const [buttonContent] = useIntlMessage(locKey);
    return (
      <Button
        ref={ref}
        className={classnames('qau-default-button', className, { secondary, loading })}
        onClick={onClick}
        disabled={disabled}
        hidden={hidden}
        locKey={loading ? undefined : locKey}
        aria-label={buttonContent}
        aria-disabled={disabled || loading}
        {...props}
      >
        {loading && (
          <>
            <SvgIconUse id="loading-thin" className="btn-spinner" />
            <span>{buttonContent}</span>
          </>
        )}
      </Button>
    );
  },
);

DefaultButton.displayName = 'DefaultButton';

DefaultButton.propTypes = {
  className: PropTypes.string,
  locKey: PropTypes.string,
  loading: PropTypes.bool,
  onClick: PropTypes.func.isRequired,
  hidden: PropTypes.bool,
  disabled: PropTypes.bool,
  secondary: PropTypes.bool,
};

export default DefaultButton;
